import { useContext } from "react";
import ReactVisibilitySensor from "react-visibility-sensor";
import { LangContext } from "../../App";

type BorderLeftCardTwoProps = {
    titleOne? : string;
    titleTwo? : string;
    subtitleOne? : string;
    subtitleTwo? : string;
}

const BorderLeftCardTwo = ({
    titleOne,
    titleTwo,
    subtitleOne,
    subtitleTwo,
} : BorderLeftCardTwoProps) => {
    const { lang } = useContext(LangContext)

  return (
    <ReactVisibilitySensor
        partialVisibility
    >
    {({isVisible} : any) => (
        <div className={`border-left-card-two ${lang ? "rtl" : ""}`}>
            <div className={`card-container ${isVisible ? "visible" : ""}`}>
                <p className={`card-subtitle`}>{subtitleOne}</p>
                <h3 className={`card-title`}>{titleOne}</h3>
                <p className={`card-subtitle`}>{subtitleTwo}</p>
                <h3 className={`card-title`}>{titleTwo}</h3>
            </div>
        </div>
    )}
    </ReactVisibilitySensor>
  )
}

export default BorderLeftCardTwo